import React, {useState, useEffect, useCallback, useRef} from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import { pushGtmValues, BAPPgetElementById } from "@bappweb/utils"
import Page from "@smpu-web/globalmodules/page"
import CalculateForm from "./calculateform"
import SssList from "./ssslist"
import Notes from "./notes"
import LandingHeader from "./landingheader"
import InfoBox from "./infobox"
import Toolbar from "./toolbar"

const getQueryStringValue = (paramName, defaultValue) => {
  const queryParams = new URLSearchParams(window.location.search)
  if (queryParams){
    let retVal:any = queryParams.get(paramName)
    if (retVal){
      return retVal
    }
    return defaultValue
  }
}

const Landing = (props) => {
  const ref = useRef() as React.RefObject<HTMLDivElement>

  const [bottomToolbarVisible, setBottomToolbarVisible] = useState(false)
  const applyButtonId = "applyNowButton"
  const buttonText = "Hemen Başvur"

  const [cid, setCid] = useState(() => getQueryStringValue("cid", ""))

  const handleScroll = useCallback(() => {
    const applyBtn = BAPPgetElementById(applyButtonId)
    let rect = { bottom: 0 }
    if (applyBtn) {
        rect = applyBtn.getBoundingClientRect()
        setBottomToolbarVisible(rect?.bottom <= 0)
    }
  }, [])

  useEffect(() => {
    pushGtmValues({
      event: "virtual_page_view",
      content_group: "tasit_kredisi",
      pageName: '/basvuru/tasit-kredisi/0/landing',
      pageTitle: 'Taşıt Kredisi Başvurusu'
    })
    
    const block = ref.current
    block?.addEventListener("scroll", handleScroll) // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const onToolbarButtonClick = (e) => {
    // TOOD
    //BAPPgetElementById(applyButtonId).click() 
  }

  return (
    <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
      <LandingHeader cid={cid} />
      <Grid type="main" className="landing-page-main">
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <CalculateForm cid={cid} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <Block className="text-section">
              <Element type="p" className="bold">
                {"Her Bütçeye Uygun Taşıt Kredisi Akbank’ta!"}
              </Element>
              <Element type="p" className="normal">
                {"Aracınızı seçin, uygun ödeme koşullarıyla kira öder gibi araç sahibi olun!"}
              </Element>
            </Block>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <Page padding={false}>
              <InfoBox id="infobox1" img="img/tasitkredisi/sifir-oto.png" text1="Taşıt Kredisi" text2={"Akbank'a gelin, 0 km taşıt kredinizi marka ve model fark etmeden rahatça kullanın!"}/>
              <InfoBox id="infobox2" img="img/tasitkredisi/ikinci-el-oto.png" text1="2. El Taşıt Kredisi" text2="Akbank'a gelin, ikinci el taşıt kredinizi marka ve model fark etmeden rahatça kullanın!"/>
            </Page>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <SssList />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <Notes />
          </Col>
        </Row>
      </Grid>
      <Toolbar onApplyClick={onToolbarButtonClick} scrollHref={props.showCalculateForm ? "" : "#landing-page-wrapper"} 
        isVisible={bottomToolbarVisible} text={buttonText}/>
    </Block>
  )
}

export default Landing
